import { Box } from "@mui/material";
import ProfileCard from "./ProfileCard";
import ExperienceStats from "./ExperienceStats";
import GeneralInfo from "./GeneralInfo";
import SocialMedia from "./SocialMedia";

const ProfileSidebar = ({ user, profile, reputacion }) => {
  return (
    <Box className="profile-sidebar">
      <ProfileCard user={user} profile={profile} />
      <ExperienceStats user={user} reputacion={reputacion} />
      <GeneralInfo user={user} profile={profile} />
      <SocialMedia user={user} profile={profile} />
    </Box>
  );
};

export default ProfileSidebar;
